import { LoginUserResponse } from "@/types";

export const changedEvents = (user: LoginUserResponse) => {
  let changed = 0;

  if (user.user.changed_events_by_month) {
    user.user.changed_events_by_month.forEach((element) => {
      if (user.current_kickoff !== element?.kickoff_date) return;

      changed = element.changed_events;
    });
  }

  return changed;
};
